module.exports = __webpack_public_path__ + "static/media/loading-logo-left.8cf91a34.png";